import { render } from "./BillingSupportCard.vue?vue&type=template&id=43685c71&scoped=true"
import script from "./BillingSupportCard.vue?vue&type=script&lang=js"
export * from "./BillingSupportCard.vue?vue&type=script&lang=js"

import "./BillingSupportCard.vue?vue&type=style&index=0&id=43685c71&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43685c71"]])

export default __exports__